import { Doughnut,mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartTitle: {type: String},
    maxLegendLength: {type: Number, default: 4},
    maxLegendLableLenght: {
      type: Number,
      default: 15
    }
  },
  data() {
    return {
      options: {
        aspectRatio: 5,
        maintainAspectRatio: true,
        responsive: true,
        title: {
          display: !!this.$props.chartTitle,
          position: 'top',
          fullWidth: true,
          fontSize: 20,
          padding: 0,
          text: this.$props.chartTitle,
        },
        legend: {
          position: "right",
          fullWidth: false,
          labels: {
            fontSize: 14,
            boxWidth: 10,
            generateLabels: this.customLabels()
          }
        },
        layout: {
          padding: {
            top: 0,
            bottom: 0,
            left: 50,
            right: 50,
          }
        },
        tooltips: {
          callbacks: {
            label: this.addPercentage
          }
        },
      },
    };
  },
  methods: {
      customLabels () {
        const lenghtLimit = this.maxLegendLableLenght;
        return (chart) => {
          const labels = _.take(
            _.zipWith(
              chart.data.labels.map(item =>  {
                let isLabelLonger = item.length > lenghtLimit;
                // return item.substring(0, Math.min(item.length - 1, lenghtLimit)) + (isLabelLonger ? "..." : "");
                item = item.substring(0, lenghtLimit-3 ) + (isLabelLonger ? "..." : "");

                if (item.length < lenghtLimit) {
                  item += new Array(lenghtLimit -item.length).fill(' ').join("");
                }
                return item;
              }),
              chart.data.datasets[0]?.backgroundColor,
              chart.data.datasets[0]?.data,
              (label, color, data) => {
                return _.zipObject(
                  [
                    'label',
                    'color',
                    'data',
                  ],
                  [label, color, data]
                );
              }
            ),
            this.maxLegendLength,
          ).map((item, index) => {
            return {
              text: item.label,
              fillStyle: item.color,
              datasetIndex: index,
              index: index,
            };
          });

          if (chart.data.labels.length > this.maxLegendLength) {
            labels.push({
              text: this.$t('Other'),
              fillStyle: chart.data.datasets[0]?.backgroundColor[chart.data.labels.length],
            });
          }
          return labels
        };
      },
      addPercentage (tooltipItem, data) {
        let label = data.labels[tooltipItem.index] || '';

        if (label) {
          label += ': ';
        }

        label += `${data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]} %`;
        return label;
      }
  },

  mounted () {
    // if this.$props.chartData.l maxLegendLength
    if (this.$props.chartData?.labels.length < this.maxLegendLength) {
      this.$props.chartData.datasets[0].backgroundColor = _.take(
        this.$props.chartData.datasets[0].backgroundColor,
        this.$props.chartData?.labels.length
      );
    }

    this.renderChart(
      this.$props.chartData,
      this.$data.options,
    )
  },

}
